import React, { useState, useEffect, useRef } from 'react';
import Basic from '../../Components/Basic/Basic'; 
import PortfolioCard from '../../Components/PortfolioCard';
import SecuritiesHeader from '../../Components/Securities/SecuritiesHeader';
import SecuritiesFum from '../../Components/Securities/SecuritiesFum';
import SecuritiesSecurities from '../../Components/Securities/SecuritiesSecurities';
import SecuritiesInvestors from '../../Components/Securities/SecuritiesInvestors';
import SecuritiesDocs from '../../Components/Securities/SecuritiesDocs';
import SecuritiesAcquisition from '../../Components/Securities/SecuritiesAcquisition';
import SecuritiesFees from '../../Components/Securities/SecuritiesFees';
import { 
  get_user_accounts, 
  get_user_info, 
  get_account_detail, 
  get_fund_managers,
  get_fum_securities
} from '../../services/common';
import moment from 'moment';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


const chartOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Chart 1 - Last Month',
    },
  },
};

const Securities = ({ accountSlug: propAccountSlug }) => {
  const systemToken = localStorage.getItem('systemToken') || "";
  
  // Account slug for determining colors (from props, URL params, or default)
  const getAccountSlugFromStorage = () => {
    return window.localStorage.getItem('active_page') || 'securities';
  };
  
  // Force securities for this component
  const accountSlug = propAccountSlug || 'securities';
  
  // Debug: log what accountSlug is being used
  console.log('Current accountSlug:', accountSlug);
  
  // Color mapping based on account slug
  const getAccountColors = (slug) => {
    const colorMap = {
      'paymaster': {
        gradient: 'bg-purple-gradient',
        tailwindGradient: 'from-purple-600 to-pink-200',
        bgClass: 'bg-purple-gradient',
        color: '#7957F5',
        colorName: 'purple',
        textColor: 'text-white',
        isDark: false
      },
      'fum': {
        gradient: 'bg-yellow-gradient', 
        tailwindGradient: 'from-orange-400 to-yellow-500',
        bgClass: 'bg-yellow-gradient',
        color: '#fdad41',
        colorName: 'orange',
        textColor: 'text-white',
        isDark: false
      },
      'securities': {
        gradient: 'bg-black-gradient',
        tailwindGradient: 'from-gray-600 to-gray-700',
        bgClass: 'bg-black-gradient',
        color: '#494949',
        colorName: 'black',
        textColor: 'text-white',
        isDark: true
      },
      'property': {
        gradient: 'bg-brown-gradient',
        tailwindGradient: 'from-amber-700 to-amber-800',
        bgClass: 'bg-brown-gradient',
        color: '#ad8e8e',
        colorName: 'brown',
        textColor: 'text-white',
        isDark: false
      },
      'commodities': {
        gradient: 'bg-blue-gradient',
        tailwindGradient: 'from-blue-400 to-blue-500',
        bgClass: 'bg-blue-gradient',
        color: '#33bfff',
        colorName: 'blue',
        textColor: 'text-white',
        isDark: false
      },
      'custodian': {
        gradient: 'bg-dark-gradient',
        tailwindGradient: 'from-gray-900 to-black',
        bgClass: 'bg-dark-gradient',
        color: '#0a0909',
        colorName: 'dark',
        textColor: 'text-white',
        isDark: true
      },
      'my-investment': {
        gradient: 'bg-gradient-to-r',
        tailwindGradient: 'from-green-500 to-green-400',
        bgClass: 'bg-green-gradient',
        color: '#22b931',
        colorName: 'green',
        textColor: 'text-white',
        isDark: false
      },
      'crypto': {
        gradient: 'bg-crypto',
        tailwindGradient: 'from-indigo-900 to-indigo-950',
        bgClass: 'bg-crypto',
        color: '#08003b',
        colorName: 'black',
        textColor: 'text-white',
        isDark: true
      },
      'private-wealth': {
        gradient: 'bg-crypto',
        tailwindGradient: 'from-indigo-900 to-indigo-950',
        bgClass: 'bg-crypto',
        color: '#08003b',
        colorName: 'black',
        textColor: 'text-white',
        isDark: true
      }
    };
    
    return colorMap[slug] || colorMap['securities']; // Default to securities colors
  };
  
  const accountColors = getAccountColors(accountSlug);
  
  // State variables
  const [userName, setUserName] = useState('');
  const [userInfo, setUserInfo] = useState({
    user_name: '',
    join_date: '',
    default_currency: 'AUD',
    default_currency_icon: '$'
  });
  const [customerAccounts, setCustomerAccounts] = useState([]);
  const [totalAcBalance, setTotalAcBalance] = useState(0);
  const [totalActiveDefaultBalance, setTotalActiveDefaultBalance] = useState(0);
  const [totalArchiveDefaultBalance, setTotalArchiveDefaultBalance] = useState(0);
  const [defaultCurrencyIcon, setDefaultCurrencyIcon] = useState('$');
  const [defaultCurrency, setDefaultCurrency] = useState('AUD');
  const [subac, setSubac] = useState([]);
  const [selectedSubac, setSelectedSubac] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [activeSubac, setActiveSubac] = useState('');
  const [localStorageData, setLocalStorageData] = useState({});
  const [loadOn, setLoadOn] = useState(1);
  
  const [security, setSecurity] = useState({
   
  });
  
  const [allSecurities, setAllSecurities] = useState([]);
  const [fundManagers, setFundManagers] = useState([]);
  const [activeFumId, setActiveFumId] = useState('');
  const [activeTab, setActiveTab] = useState('');

  // Chart state variables
  const [last12Months] = useState([
    moment().subtract(11, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(10, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(9, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(8, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(7, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(6, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(5, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(4, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(3, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(2, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(1, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(0, "month").startOf("month").format('MMM, YYYY'),
  ]);
  const [activeChart, setActiveChart] = useState(1);
  const [onChart, setOnChart] = useState(0);
   


// const [chart1, setChart1] = useState(chart1_dummy);
// const [chart2, setChart2] = useState(chart2_dummy);
// const [chart3, setChart3] = useState(chart3_dummy);
// const [chart4, setChart4] = useState(chart4_dummy);
// const [chart5, setChart5] = useState(chart5_dummy);

  const [chart1, setChart1] = useState([1000, 2000, 1500, 3000]);
  const [chart2, setChart2] = useState([2500, 3000, 3500]);
  const [chart3, setChart3] = useState([4000, 4500, 5000, 5500, 6000, 6500]);
  const [chart4, setChart4] = useState([7000, 7500, 8000, 8500, 9000, 9500, 10000, 10500, 11000, 11500, 12000, 12500]);
  const [chart5, setChart5] = useState([13000, 13500]);

  const STORAGE_KEY = "caprock-local";

  // Chart options
  const chartOptions1 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#494949',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: ["Week 1", "Week 2", "Week 3", "Week 4"],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#494949'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };

   

  const chartOptions2 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#494949',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#494949'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };

 

  const chartOptions3 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#494949',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        moment().subtract(5, "month").startOf("month").format('MMM'),
        moment().subtract(4, "month").startOf("month").format('MMM'),
        moment().subtract(3, "month").startOf("month").format('MMM'),
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#494949'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };


  const chartOptions4 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#494949',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: last12Months
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#494949'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };

   

  const chartOptions5 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#494949',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        "Year 1", "Year 2"
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#494949'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };


  // API functions
  const fetch_user_accounts = async () => {
    try {
      const data = await get_user_accounts(systemToken);
      if (data.success === 200) {
        let totalDBalance = 0;
        setTotalAcBalance(data.t_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setTotalActiveDefaultBalance(0);
        setTotalArchiveDefaultBalance(0);
        
        const acData = data.accounts;
        let totalActive = 0;
        let totalArchive = 0;
        
        for (let i = 0; i < acData.length; i++) {
          if (acData[i].userac_status === 1) {
            totalActive += acData[i].default_currency_balance;
          } else {
            totalArchive += acData[i].default_currency_balance;
          }
          totalDBalance += acData[i].default_currency_balance;
        }
        
        setTotalActiveDefaultBalance(totalActive);
        setTotalArchiveDefaultBalance(totalArchive);
        
        // Calculate percentages
        const accountsWithPercent = acData.map(account => ({
          ...account,
          ac_percent: (100 * account.default_currency_balance / totalActive)
        }));
        
        setCustomerAccounts(accountsWithPercent);
      }
    } catch (error) {
      console.error('Error fetching user accounts:', error);
    }
  };

  const fetch_user_info = async () => {
    try {
      const data = await get_user_info(systemToken);
      
      if (data.success === 200) {
        const userInf = data.profile;
        userInf.join_date = userInf.join_date ? moment(userInf.join_date).format('DD MMM, YYYY') : '';
        setUserInfo(userInf);
        setDefaultCurrency(userInf.default_currency);
        setDefaultCurrencyIcon(userInf.default_currency_icon);
      }
    } catch (error) {
      console.error('Error fetching user info:', error);
      // Set default values if API fails
      setUserInfo({
        user_name: 'Demo User',
        join_date: '01 Jan, 2024',
        default_currency: 'AUD',
        default_currency_icon: '$'
      });
      setDefaultCurrency('AUD');
      setDefaultCurrencyIcon('$');
    }
  };

  const fetch_account_detail = async (ac_name) => {
    try {
      const data = await get_account_detail(systemToken, ac_name || accountSlug);
      
      if (data.success === 200) {
        const securityData = data.ac_info;
        securityData.userac_establish_date = moment(securityData.userac_establish_date).format('DD MMM, YYYY');
        setSecurity(securityData);
        
        
        setSubac(data.ac_data.subaccounts);
        
        // Set active subaccount
        const subII = window.localStorage.getItem('selected_security_subac_id');
        
        let subId = '';
        if (subII && subId > 0) {
          subId = subII;
        } else {
          subId = data.ac_data.subaccounts[data.ac_data.subaccounts.length - 1].subac_id;
        }
        setActiveSubac(subId);
        filterTrans(subId);
        
        // Process chart data
        const chartInfo = data.chart_data;
        if (data.chart_data.length > 0) {
          setChart1(chartInfo.last_month_chart);
          setChart2(chartInfo.three_month_chart);
          setChart3(chartInfo.six_month_chart);
          setChart4(chartInfo.year_chart.reverse());
          // setChart1([1000, 2000, 1500, 3000]);
          // setChart2([2500, 3000, 3500]);
          // setChart3([4000, 4500, 5000, 5500, 6000, 6500]);
          // setChart4([7000, 7500, 8000, 8500, 9000, 9500, 10000, 10500, 11000, 11500, 12000, 12500]);
        }
        
        // Process all time chart
        const allChart = chartInfo.all_chart || []; // Fixed: Added fallback for undefined
        const newChart5 = [];
        const labels = [];
        
        if (allChart.length === 1) {
          newChart5.push(0);
          labels.push((allChart[0].year - 1));
        }
        
        for (let i = 0; i < allChart.length; i++) {
          newChart5.push(allChart[i].balance);
          labels.push(allChart[i].year);
        }
        setChart5(newChart5);
        setOnChart(1);
      }
    } catch (error) {
      console.error('Error fetching account detail:', error);
      // Set default values if API fails
      setSecurity({
       
      });
      setSubac([]);
      setActiveSubac(1);
      setOnChart(1);
    }
  };

  const fetch_fund_managers = async () => {
    try {
      const data = await get_fund_managers(systemToken);
      if (data.success === 200) {
        setFundManagers(data.fund_managers);
      }
    } catch (error) {
      console.error('Error fetching fund managers:', error);
    }
  };

  // Event handlers
  const changeFum = (fumId, tab) => {
    localStorage.setItem('selected_fum_id', fumId);
    localStorage.setItem('selected_securities_tab', tab);
    
    setActiveFumId(fumId);
    setActiveTab(tab);
    
    if (typeof tab === 'undefined' || tab === null || tab === '' || typeof fumId === 'undefined' || fumId === null || fumId === '') {
      setActiveTab('');
    }
  };

  const filterTrans = (subacId) => {
    if (typeof subacId !== "undefined" && subacId > 0) {
      localStorage.setItem('selected_security_subac_id', subacId);
      setActiveSubac(subacId);
      
      const fData = [];
      const tData = subac;
      for (let i = 0; i < tData.length; i++) {
        if (tData[i]['subac_id'] == subacId) {
          fData[i] = tData[i];
        }
      }
      const filteredData = fData.filter(value => Object.keys(value).length !== 0);
      setSelectedSubac(filteredData);
    }
  };

  // Lifecycle methods
  useEffect(() => {
    const js = JSON.parse((window.localStorage.getItem(STORAGE_KEY) || "{}"));
    
    if (typeof js !== 'undefined' && typeof js['access-token'] !== 'undefined') {
      setLocalStorageData(js);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
      // Redirect to sign-in (implement navigation logic)
      console.log('Redirect to sign-in');
    }
    
    document.title = `Securities || Caprock Merchant Platform`;
    window.localStorage.setItem('active_page', accountSlug);
  }, []);

  useEffect(() => {
    setUserName('');
    fetch_user_accounts();
    fetch_user_info();
    fetch_account_detail(accountSlug);
    fetch_fund_managers();
    
    // Check for stored fund manager and tab
    const fId = localStorage.getItem('selected_fum_id');
    const fTab = localStorage.getItem('selected_securities_tab');
    
    if (typeof fId !== 'undefined' && typeof fTab !== 'undefined') {
      setActiveFumId(fId);
      setActiveTab(fTab);
      changeFum(fId, fTab);
    }
    
    setTimeout(() => setLoadOn(0), 500);
  }, [localStorageData]);

  return (
    <>
      <Basic />
     
      
      <div className="w-full p-5 mr-80 box-border mt-5">
        <section className="w-full">
          <div className="flex flex-wrap gap-4 mb-6 w-full">
            {/* Left Column - Account Details and Portfolio */}
            <div className="flex-1 min-w-0" style={{ maxWidth: '33.33%' }}>
              {/* Account Details Card */}
              <div className={`bg-gradient-to-br ${accountColors.tailwindGradient} rounded-lg p-4 text-white mb-4`} style={{ minHeight: '300px' }}>
                <div className="flex flex-wrap -mx-4">
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Account Type</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      Securities Management
                    </h5>
                  </div>
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Balance</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      {defaultCurrency} {defaultCurrencyIcon} {security?.default_currency_balance?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                    </h5>
                  </div>
                </div>
                <div className="flex flex-wrap -mx-4 mt-3">
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Account Name</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      {security?.userac_name || 'N/A'}
                    </h5>
                  </div>
                  <div className="w-1/2 px-4 overflow-y-auto" style={{ maxHeight: '125px' }}>
                    {subac && subac.length > 0 ? subac.map((subacItem) => (
                      <h5 key={subacItem.subac_id} className="text-white text-xs mt-2">
                        {subacItem.subac_name}<br />
                        {subacItem.currency_name} {subacItem.currency_symbol}{subacItem.investment_valuation?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                      </h5>
                    )) : (
                      <h5 className="text-white text-xs mt-2">No subaccounts available</h5>
                    )}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-4 mt-3">
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Account Reference</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      #{security?.userac_reference_code || 'N/A'}
                    </h5>
                  </div>
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Date Account Established</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      {security?.userac_establish_date || 'N/A'}
                    </h5>
                  </div>
                </div>
              </div>

              {/* Portfolio Card */}
              {/* <PortfolioCard
                defaultCurrencyIcon={defaultCurrencyIcon}
                customerAccounts={customerAccounts}
                totalActiveDefaultBalance={totalActiveDefaultBalance}
                defaultCurrency={defaultCurrency}
              /> */}
            </div>

            {/* Right Column - Securities Details and Chart */}
            <div className="flex-1 min-w-0" style={{ maxWidth: '66.67%' }}>
              {/* Securities Details */}
              <div className="bg-white rounded-lg mb-4">
                <div className="flex justify-between items-center py-4 px-6 border-b">
                  <div>
                    <h5 className="text-lg font-bold text-gray-700">
                      <b>Securities Details</b><br />
                      <p className="text-sm text-gray-500" id="transSubTitle"></p>
                    </h5>
                  </div>
                  <div className="w-64">
                    <select 
                      className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      id="selected_fum_id" 
                      onChange={(e) => changeFum(e.target.value, 'fum')}
                      value={activeFumId}
                    >
                      <option value="">Select Fund Manager</option>
                      {fundManagers.map((fum) => (
                        <option key={fum.fum_id} value={fum.fum_id}>
                          {fum.fum_name} ({fum.currency_name})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div className="p-6">
                  {/* Tab Navigation */}
                  <SecuritiesHeader 
                    activeTab={activeTab}
                    fumId={activeFumId}
                    onTabChange={changeFum}
                  />

                  {/* Tab Content */}
                  <div className="min-h-64">
                    {(!activeFumId || activeFumId === '' || activeFumId === null || activeFumId === 'null') ? (
                      <div className="text-center py-8">
                        <p className="text-gray-500">
                          Please select fund manager to view records
                        </p>
                      </div>
                    ) : (
                      <>
                        {activeTab === 'fum' && <SecuritiesFum fumId={activeFumId} />}
                        {activeTab === 'securities' && (
                           <SecuritiesSecurities fumId={activeFumId} />
                         
                        )}
                        {activeTab === 'investors' && <SecuritiesInvestors fumId={activeFumId} />}
                        {activeTab === 'security_loan_note' && <SecuritiesDocs fumId={activeFumId} docType="security_loan_note" />}
                        {activeTab === 'security_register' && <SecuritiesDocs fumId={activeFumId} docType="security_register" />}
                        {activeTab === 'docs' && <SecuritiesDocs fumId={activeFumId} docType="docs" />}
                        {activeTab === 'acquisition' && <SecuritiesAcquisition fumId={activeFumId} />}
                        {activeTab === 'fees' && <SecuritiesFees fumId={activeFumId} />}
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Chart Section */}
              <div className="bg-white rounded-lg">
                <div className="border-b">
                  <div className="flex justify-between items-center py-2 px-2">
                    <ul className="flex space-x-8">
                      <li>
                        <button 
                          onClick={() => setActiveChart(1)} 
                          className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                            activeChart === 1 
                              ? 'text-blue-500 border-blue-500' 
                              : 'text-gray-500 border-transparent hover:text-gray-700'
                          }`}
                        >
                          <b>Last Month</b>
                        </button>
                      </li>
                      <li>
                        <button 
                          onClick={() => setActiveChart(2)} 
                          className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                            activeChart === 2 
                              ? 'text-blue-500 border-blue-500' 
                              : 'text-gray-500 border-transparent hover:text-gray-700'
                          }`}
                        >
                          <b>3M</b>
                        </button>
                      </li>
                      <li>
                        <button 
                          onClick={() => setActiveChart(3)} 
                          className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                            activeChart === 3 
                              ? 'text-blue-500 border-blue-500' 
                              : 'text-gray-500 border-transparent hover:text-gray-700'
                          }`}
                        >
                          <b>6M</b>
                        </button>
                      </li>
                      <li>
                        <button 
                          onClick={() => setActiveChart(4)} 
                          className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                            activeChart === 4 
                              ? 'text-blue-500 border-blue-500' 
                              : 'text-gray-500 border-transparent hover:text-gray-700'
                          }`}
                        >
                          <b>Year</b>
                        </button>
                      </li>
                      <li>
                        <button 
                          onClick={() => setActiveChart(5)} 
                          className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                            activeChart === 5 
                              ? 'text-blue-500 border-blue-500' 
                              : 'text-gray-500 border-transparent hover:text-gray-700'
                          }`}
                        >
                          <b>All</b>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="p-2">
                  {onChart === 1 ? (
                    <div className="h-80 flex items-center justify-center">
                     {activeChart === 1 && <Line data={{ labels: ["Week 1", "Week 2", "Week 3", "Week 4"], datasets: [{ label: 'Balance', data: chart1, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions1} />}
                    {activeChart === 2 && <Line data={{ labels: ["Month 1", "Month 2", "Month 3"], datasets: [{ label: 'Balance', data: chart2, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions2} />}
                    {activeChart === 3 && <Line data={{ labels: ["Month 1", "Month 2", "Month 3", "Month 4", "Month 5", "Month 6"], datasets: [{ label: 'Balance', data: chart3, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions3} />}
                    {activeChart === 4 && <Line data={{ labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], datasets: [{ label: 'Balance', data: chart4, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions4} />}
                    {activeChart === 5 && <Line data={{ labels: ["Year 1", "Year 2"], datasets: [{ label: 'Balance', data: chart5, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions5} />}      </div>
                  ) : (
                    <div className="h-64 flex items-center justify-center bg-gray-50 rounded border-2 border-dashed border-gray-300">
                      <span className="text-gray-500">Loading...</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Securities;
